import { render, staticRenderFns } from "./ProductsListWidget-ProductCards.vue?vue&type=template&id=2c00ab52&"
import script from "./ProductsListWidget-ProductCards.vue?vue&type=script&lang=js&"
export * from "./ProductsListWidget-ProductCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports